import { QueryClient } from "react-query";

// Shared React Query client so non-component modules (e.g. the socket manager) can
// invalidate/refetch queries such as ["chatrooms"] in response to real-time server
// events — used to update the inbox instantly on human-handoff request/resolve.
export const queryClient = new QueryClient();
